import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { Dispatch, memo, SetStateAction } from "react";

const InstallmentActiveModal = ({
  open,
  setOpen
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => (
  <Modal
    animate="normal"
    dialogClassName="lg:max-w-[439px]"
    mobileHeight="auto"
    onClose={() => setOpen(false)}
    open={open}
  >
    <div>
      <div className="m-0 flex items-center justify-between pb-4">
        <div className="flex cursor-pointer items-center gap-4 text-lg font-medium text-opacity-[87%]">
          پرداخت اقساطی با اسنپ‌پی{" "}
        </div>
        <MaterialIcon
          className="cursor-pointer text-2xl opacity-60"
          name="close"
          onClick={() => setOpen(false)}
          variant="outlined"
        />
      </div>
      <div className="text-body-2 text-on-surface-high-emphasis">
        <div className="mb-4">
          پرداخت <span className="text-body-1 font-bold">۴ قسطه</span> اسنپ‌پی،{" "}
          <span className="text-body-1 font-bold">
            بدون نیاز به ضامن، چک و سفته
          </span>{" "}
          انجام می‌شود.
        </div>
        <ul className="list-disc pr-6">
          <li>قسط اول را موقع خرید و نقدی پرداخت می‌کنید.</li>
          <li>
            درصورتی‌که مبلغ خرید بیشتر از اعتبارتان باشد، مابه‌تفاوت را همراه
            قسط اول پرداخت می‌کنید.
          </li>
        </ul>
      </div>
      <div className="border-outline-thin border-b border-dashed pb-4 lg:pb-6">
        <div className="text-overline flex w-full justify-between py-4 lg:pt-6">
          <div>
            مثال ۱
            <div className="text-overline text-on-surface-high-emphasis">
              مبلغ خرید بیشتر از اعتبار
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div>
              مبلغ خرید
              <div className="text-overline text-on-surface-high-emphasis">
                ۴ میلیون تومان
              </div>
            </div>
            <span>{`>`}</span>
            <div>
              اعتبار شما
              <div className="text-overline text-on-surface-high-emphasis">
                ۲ میلیون تومان
              </div>
            </div>
          </div>
        </div>
        <div className="flex w-full gap-1">
          <div className="bg-dim-background text-caption w-1/2 rounded-r-[32px] p-2 text-center">
            قسط اول
            <div className="font-bold"> ۲٫۵ میلیون تومان</div>
          </div>
          <div className="bg-transparent-secondary text-caption text-ventures-fin-tech w-1/2 rounded-l-[32px] p-2 text-center">
            سه قسط بعدی (هرکدام){" "}
            <div className="font-bold"> ۵۰۰ هزار تومان</div>
          </div>
        </div>
      </div>
      <div>
        <div className="text-caption text-on-surface-medium-emphasis flex w-full justify-between py-4 lg:pt-6">
          <div>
            مثال ۲
            <div className="text-overline text-on-surface-high-emphasis">
              مبلغ خرید کمتر از اعتبار
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div>
              مبلغ خرید
              <div className="text-overline text-on-surface-high-emphasis">
                ۲ میلیون تومان
              </div>
            </div>
            <span>{`=<`}</span>
            <div>
              اعتبار شما
              <div className="text-overline text-on-surface-high-emphasis">
                ۲ میلیون تومان
              </div>
            </div>
          </div>
        </div>
        <div className="flex w-full gap-1">
          <div className="bg-dim-background text-caption w-1/2 rounded-r-[32px] p-2 text-center">
            قسط اول
            <div className="font-bold"> ۵۰۰ هزار تومان</div>
          </div>
          <div className="bg-transparent-secondary text-caption text-ventures-fin-tech w-1/2 rounded-l-[32px] p-2 text-center">
            سه قسط بعدی (هرکدام){" "}
            <div className="font-bold"> ۵۰۰ هزار تومان</div>
          </div>
        </div>
      </div>
      <div className="flex justify-end pt-4">
        <Button
          color="secondary"
          onClick={() => setOpen(false)}
          variant="contained"
        >
          متوجه شدم
        </Button>
      </div>
    </div>
  </Modal>
);

export default memo(InstallmentActiveModal);
